export function isThirdPartySource (query = {}) {
  const ts = query.ts
  return ts !== undefined && ts !== null && String(ts).trim() !== ''
}



// WEBPACK FOOTER //
// ./src/utils/thirdParty.js